import getClient from "./client";

/**
 * レビューを作成
 */
export const createReview = async (params) => {
  return getClient().post(`/reviews`, { review: params });
};
